import { fetchReferrals, fetchSortReferrals } from "@/api/referralService";

export default {
  //Fetch referrals
  async fetchReferrals({ commit }, pageNumber) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });

      const response = await fetchReferrals(pageNumber);
      const referrals = response.data.data;
      commit("SET_REFERRAL_DATA", referrals);
      commit("SET_REFERRAL_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your squad arrived.",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Fetch sorted referrals
  async fetchSortedReferrals({ commit }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });

      const response = await fetchSortReferrals(payload);
      const referrals = response.data.data;
      commit("SET_REFERRAL_DATA", referrals);
      commit("SET_REFERRAL_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your squad arrived",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Copy referral link
  async copyReferralLink({ commit }) {
    // eslint-disable-next-line no-useless-catch
    commit(
      "SHOW_SNACKBAR",
      {
        text: "Referral link copied! 📋🎉",
        color: "success",
      },
      { root: true }
    );
  },
};
